import { Box, BoxProps } from "@mui/material";
import React from "react";
import styles from "./UsageGuideDialog.module.scss";

export const Caption = React.memo((props: BoxProps) => (
  <Box {...props} className={styles.caption} />
));
